module.exports = __webpack_public_path__ + "img/finish.871ac138.png";